var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-no-results"},[_vm._m(0),_c('span',{staticClass:"search-no-results__text"},[_vm._v("\n    Sin resultados para:\n    "),_c('span',[_vm._v(_vm._s(_vm.query))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-no-results__image"},[_c('img',{attrs:{"src":require("@/assets/img/components/no-search-results-3.png")}})])
}]

export { render, staticRenderFns }